import React, { useState, useEffect } from 'react';
import styles from './RegionWiseResults.module.css';

const RegionWiseResults = () => {
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const timestamp = `${hours}${minutes}`;

        const response = await fetch(`/result/ACF2021/json/element358.json?ver=${timestamp}`, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch region data');
        }

        const data = await response.json();
        setRegions(data.items);
      } catch (err) {
        console.error('Error fetching data:', err);
        setError('Failed to load region data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const filteredRegions = regions;

/*  const filteredRegions = regions.filter(region =>
    region.Region.toLowerCase().includes(searchTerm.toLowerCase())
  );*/

  if (loading) return <div className={styles.loading}>Loading region data...</div>;
  if (error) return <div className={styles.error}>{error}</div>;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>Bihar Region Wise Results</h2>
        {/*<div className={styles.searchBox}>
          <input
            type="text"
            placeholder="Search region..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className={styles.searchInput}
            hidden={true}
          />
        </div>*/}
      </div>

      <div className={styles.tableContainer}>
        <table className={styles.resultsTable}>
          <thead>
          <tr>
            <th>Region</th>
            <th>Total Seats</th>
            <th>NDA <br/> 2025<span>(2020)</span></th>
            <th>INDIA <br/> 2025<span>(2020)</span></th>
            <th>Others <br/> 2025<span>(2020)</span></th>
          </tr>
          </thead>
          <tbody>
          {filteredRegions.map((region, index) => (
            <tr key={index}>
              <td>{region.Region}</td>
              <td>{region.Total_Seats}</td>
              <td className={styles.nda}><span className={styles.partyBadge} style={{ backgroundColor: `var(--nda-color)` }}>{region.NDA_2025}</span> <span className={styles.seat_2020} > ({region.NDA_2020})</span></td>
              <td className={styles.india}><span className={styles.partyBadge} style={{ backgroundColor: `var(--india-color)` }}>{region.INDIA_2025}</span> <span className={styles.seat_2020} > ({region.INDIA_2020})</span></td>
              <td className={styles.others}><span className={styles.partyBadge} style={{ backgroundColor: `var(--others-color)` }}>{region.OTH_2025}</span> <span className={styles.seat_2020} > ({region.OTH_2020})</span></td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RegionWiseResults;